import $ from 'jquery';

export class SeoUtil {
	constructor() {
		'ngInject';
	}

	createEstateSeo(data) {
		let productPageUrl = window.location.href;
		let jsonLD = {
			"@context": "http://schema.org",
			"@type": "House",
			"url": productPageUrl,
			"photo": {
				"@type": "ImageObject",
				"url": data.images[0].url
			},
			"address": data.address + ', ' + data.city,
			"geo": {
				"@type": "GeoCoordinates",
				"latitude": data.lat,
				"longitude": data.lng
			},
			"description": data.descriptionTitle,
			"numberOfRooms": {
				"@type": "QuantitativeValue",
				"value": data.numberOfRooms
			}
		};
		$('head').append($("<script type='application/ld+json' id='schema-org-json'>" + JSON.stringify(jsonLD) + "</script>"));
	}
}

